<template>
  <div class="p-2 text-black">
    <div class="text-md font-bold">{{ title }}</div>
    <div class="text-sm mt-2">{{ description }}</div>
    <div class="mt-2"><button @click="openQRModal()" class="btn-primary mt-3">Sign Transaction</button></div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { toast_emitter } from '@/layouts/home/emitter'

// import mitt from 'mitt';
export default defineComponent({
name: 'CustomizedContent',
  props: {
    title: String,
    description: String,
    notificationId: String,
    payload: String,
  },

  setup(props){
    const openQRModal = () => {
      toast_emitter.emit('OPEN_AUTO_SIGN_CUSTOM_MODAL', {
        notificationId: props.notificationId,
        description: props.description,
        title: props.title,
        payload: props.payload
      });
    }
    return {
      openQRModal,
    }
  }
});
</script>
<style lang="scss" scoped>

</style>